<template>
    <div>
        <div class="title-box">
            系统日志
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" label-width="60px" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-form-item label="登录地址">
              <el-input v-model="queryParams.ipaddr" placeholder="请输入登录地址" clearable />
            </el-form-item>
            <el-form-item label="用户账号">
              <el-input v-model="queryParams.userName" placeholder="请输入用户账号" clearable />
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="queryParams.status" placeholder="登录状态" clearable>
                <el-option v-for="dict in sys_common_status" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue" />
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="dateRange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="info" @click="onReset">重置</el-button>
            </el-form-item>
        </el-form>
        
        <!-- 表格 -->
         <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" class="custom-table-header">
            <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="访问编号" align="center" prop="infoId" />
            <el-table-column label="用户账号" align="center" prop="userName" />
            <el-table-column label="客户端" align="center" prop="clientKey" />
            <el-table-column label="设备类型" align="center" prop="deviceType" :formatter="formatterType"/>
            <el-table-column label="地址" align="center" prop="ipaddr" />
            <el-table-column label="登录地点" align="center" prop="loginLocation" />
            <el-table-column label="操作系统" align="center" prop="os" />
            <el-table-column label="浏览器" align="center" prop="browser" />
            <el-table-column label="登录状态" align="center" prop="status" :formatter="formatterStatus" />
            <el-table-column label="描述" align="center" prop="msg" />
            <el-table-column label="访问时间" align="center" prop="loginTime" width="120" />
        </el-table>

        <!-- 分页 -->
        <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryParams.pageNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="queryParams.pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { addDateRange } from '@/utils/base';
export default {
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                ipaddr: '',
                userName: '',
                status: '',
                orderByColumn: 'loginTime',
                isAsc: 'descending'
            },
            dateRange:['',''],
            // 登录状态
            sys_common_status:[],
            total:0,
            // 设备类型
            sys_device_type:[],
            tableHeight:650,
            // 表格数据
            tableData:[]
        }
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.getStatus();
        this.getList();
    },
    methods: {
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            // 你可以在这里添加你的处理代码
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化

            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            console.log('reset!');
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                startTime:"",
                endTime:"",
                oprUser:""
            }
        },
        getStatus(){
            this.getCommonStatus();
            this.getDeviceType();
        },
        getCommonStatus(){
            this.$store.dispatch("log/getCommonStatus").then((result)=>{
                this.sys_common_status = result.data;
            });
        },
        getDeviceType(){
            this.$store.dispatch("log/getDeviceType").then((result)=>{
                this.sys_device_type = result.data;
            });
        },
        getList(){
            let params = addDateRange(this.queryParams, this.dateRange);
            this.$store.dispatch('log/getLogList', params).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            });
        },
        // 状态列格式
        formatterType(row) {
            let str = "";
            for(let i=0;i<this.sys_device_type.length;i++){
                if(this.sys_device_type[i].dictValue == row.deviceType){
                    str = this.sys_device_type[i].dictLabel;
                    break;
                }
            }
            return str;
        },
        formatterStatus(row) {
            let str = "";
            for(let i=0;i<this.sys_common_status.length;i++){
                if(this.sys_common_status[i].dictValue == row.status){
                    str = this.sys_common_status[i].dictLabel;
                    break;
                }
            }
            return str;
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    // ::v-deep .el-form-item__error {
    // display: block;
    // position: absolute;
    // top: 100%;
    // left: 0;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
    }
        
    // ::v-deep.el-form-item__label::after {
    //     content: ' *';
    //     color: red;
    // }
    ::v-deep .el-table__body-wrapper{
        height: 100%;
        overflow-y: auto;
    }
</style>